class CancellationReason {
    constructor(id, value) {
        this.id = id
        this.value = value
    }

    static fromJson({ id, value }) {
        return new CancellationReason(id, value)
    }
}

export default CancellationReason
